import { GetStaticProps } from 'next';
import { useState } from 'react';
import { useOnMountFunnelMetrics } from '../../../../../components/hooks/use-on-mount-funnel-metrics';
import { PaytaxCalculatorProvider } from '../../../../../components/paytax-calculator/context';
import { IncomeTaxCalculator } from '../../../../../components/paytax-calculator/income-tax-calculator';
import { staticPropsWrapper } from '../../../../../utils/static-pages/utils';
import { handleTrack } from '../../../../../utils/tracker';

const EmbeddedCalculator = () => {
  const [financialYear, setFinancialYear] = useState('2025');
  const [financialYearCalc, setFinancialYearCalc] = useState('2025');
  useOnMountFunnelMetrics({ parentCategory: 'calculator_taxcalculator' });
  return (
    <div className="wg-container">
      <h2 className="mt-2 text-s-22 sm:text-s-20 mb-2 font-semibold">
        Income Tax Calculator - FY 2025-26
        <span className="font-normal text-s-12 pl-2">powered by</span>
        <img
          className="inline pl-1 h-5 mt-2"
          src="https://assets.clear.in/cleartax/images/1752733609_group1814221664.svg"
          alt=""
          height={16}
        />
        <span className="font-normal text-s-14 sm:hidden">ClearTax</span>
      </h2>
      <p className="text-base mb-4 sm:mb-3 sm:text-s-12 sm:hidden">
        {' '}
        E-file tax returns in 3 minutes - {''}
        <a
          href="https://cleartax.in/income-tax-efiling?utm_ref=incometax_calcuator_embed_budget_2025"
          target="_blank"
          rel="noreferrer"
          className="text-s-16 py-2 mb-6  w-full sm:py-0"
          onClick={() =>
            handleTrack({
              label: 'explore_tax_filing',
            })
          }
        >
          Explore Tax Filing
        </a>
      </p>
      <a
        href="https://cleartax.in/income-tax-efiling?utm_ref=incometax_calcuator_embed_budget_2025"
        target="_blank"
        rel="noreferrer"
        className="text-s-16 py-2 mb-6 font-semibold w-full sm:py-0 hidden sm:block"
        onClick={() =>
          handleTrack({
            label: 'explore_tax_filing',
          })
        }
      >
        E-File with ClearTax in 3 Minutes
      </a>
      <PaytaxCalculatorProvider
        value={{
          financialYear,
          setFinancialYear,
          financialYearCalc,
          setFinancialYearCalc,
        }}
      >
        <IncomeTaxCalculator showSummary={false} />
      </PaytaxCalculatorProvider>
    </div>
  );
};
export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  () => {
    return {
      props: {
        hideFooter: true,
      },
    };
  }
);
export default EmbeddedCalculator;
